// @ts-ignore
import metricsFormatTypes from 'public/shared-reports/metrics-format';
import percent from './percent'
import currency_base from './currency';
import profit_status from './profit_status';
import factor_1x from './factor_1x';
import suspiciousEvent from './suspiciousEvent';
import custom from './custom';
import icons from './icons';
import number from './number';
import main_column from './main_column';
import campaigns_external_status_propeller from './campaigns_external_status_propeller';
import yes_no from './yes-no';
import postback_sent_failed from './postback_sent_failed';
import reports_cost from './reports-cost';
import column_with_integration from './column_with_integration';
import custom_event from '@/views/formatters/custom_event';
import custom_column from '@/views/formatters/custom_column';
import {
  METRICS_CUSTOM_EVENT,
  METRICS_CUSTOM_EVENT_REVENUE,
  METRICS_CUSTOM_EVENT_HIDDEN_REVENUE,
  METRICS_CUSTOM_COLUMN,
  CAMPAIGNS_EXTERNAL_STATUS_PROPELLER,
  YES_NO,
  POSTBACK_SENT_FAILED,
  REPORTS_COST,
  COLUMN_WITH_INTEGRATION,
  SUSPICIOUS_EVENT
} from '@/services/constants/report';
import store from '@/store';

// @ts-ignore
import metricsFormat from 'public/shared-reports/metrics-format'

interface Metrics {
  value: string;
}

const currencyPrecision3 = obj => currency_base({ ...obj, decimal: 3 });
const currencyPrecision4 = obj => currency_base({ ...obj, decimal: 4 });
const currencyPrecision5 = obj => currency_base({ ...obj, decimal: 5 });
const currencyPrecision6 = obj => currency_base({ ...obj, decimal: 6 });

const percentPrecision3 = obj => percent({ ...obj, decimal: 3 });

const factor_1xPrecision3 = obj => factor_1x({ ...obj, decimal: 3 });

export const FORMATS_MAP = {
  'percent': percent,
  'percentPrecision3': percentPrecision3,
  'currency_base': currency_base,
  'profit_status': profit_status,
  'factor_1x': factor_1x,
  'factor_1xPrecision3': factor_1xPrecision3,
  'custom': custom,
  'icons': icons,
  'number': number,
  'currencyPrecision3': currencyPrecision3,
  'currencyPrecision4': currencyPrecision4,
  'currencyPrecision5': currencyPrecision5,
  'currencyPrecision6': currencyPrecision6,
  'suspiciousEvent': suspiciousEvent,
}

const metrics = Object.entries(metricsFormat as Metrics).reduce((acc, [key, value]) => {
  acc[key] = FORMATS_MAP[value]
  return acc
}, {})


export const showTotalTypeForColumn = (column)=>{
  if(column.startsWith(METRICS_CUSTOM_COLUMN)){
    const format = store.getters.getCustomColumns[(column.slice(METRICS_CUSTOM_COLUMN.length))]?.format;
    return ['currency','number', 'percent'].includes(format)
  }
  
  return column.startsWith(METRICS_CUSTOM_EVENT) || column.startsWith(METRICS_CUSTOM_EVENT_REVENUE) || column.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE) || ['percent','percentPrecision3', 'currencyPrecision3', 'currencyPrecision4', 'currencyPrecision5', 'currencyPrecision6', 'currency', 'number'].includes(metricsFormatTypes[column])
}

export default {
  ...metrics,
  main_column,

  [METRICS_CUSTOM_EVENT]: custom_event,
  [METRICS_CUSTOM_EVENT_REVENUE]: currency_base,
  [METRICS_CUSTOM_EVENT_HIDDEN_REVENUE]: currency_base,
  [METRICS_CUSTOM_COLUMN]: custom_column,
  [CAMPAIGNS_EXTERNAL_STATUS_PROPELLER]: campaigns_external_status_propeller,
  [YES_NO]: yes_no,
  [POSTBACK_SENT_FAILED]: postback_sent_failed,
  [REPORTS_COST]: reports_cost,
  [COLUMN_WITH_INTEGRATION]: column_with_integration,
  [SUSPICIOUS_EVENT]: suspiciousEvent,
}
